// External libraries
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';
import { sharpSansBold } from '@zocdoc-frontend-common/styles-typography';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

const Header = styled.h2`
    ${sharpSansBold(18, 24)}
    color: ${navy};
    padding-bottom: 14px;

    ${breakpoint.small} {
        ${sharpSansBold(24, 32, 3)}
        padding-bottom: 30px;
    }
`;

export { Header as default, Header as ModalHeader };
